import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Session lives in an httpOnly cookie sent automatically; ask the server who we are.
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
    // api is a stable module singleton; runs once on mount to restore session.
     
  }, []);

  const setSession = useCallback((data) => {
    // Auth token is set as an httpOnly cookie by the server; we only track the user object.
    setUser(data.user);
     
  }, []);

  const logout = useCallback(() => {
    api.post("/auth/logout").catch(() => {});
    setUser(false);
     
  }, []);

  const value = useMemo(
    () => ({ user, setUser, setSession, logout, loading }),
    [user, setSession, logout, loading]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
